<template>
  <section
    class="slide sec2 kenBurns overflow-hidden opacity-0 fixed w-full h-full"
    name="flywaysticks"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap table-cell align-middle text-center">
          <div class="fix-width max-w-1114px ml-auto mr-auto text-center">
            <p
              class="titleBg cropBottom left ae-2 fromCenter text-size9 uppercase font-bold font-anonymouse opacity-50 tracking-spc2 leading-lh3"
            >
              {{title}}
              <span class="block text-size10">{{subtitle}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <NextButton title="FLYAWAY STICKS" />
    <div
      class="background absolute top-0 left-0 w-full h-full bg-center bg-cover bg-no-repeat"
      :style="{backgroundImage: 'url('+bgImg+')'}"
    ></div>
  </section>
</template>

<script>
import NextButton from "../common/NextButton";

export default {
  components: { NextButton },
  props: ["title", "subtitle", "scrollBottomTxt", "bgImg"],
  name: "Section2"
};
</script>

<style scoped>
</style>